export const PERSON_CATEGORIES = [
  'Leader of the research group',
  'Team assistant',
  'Team member',
] as const

export type PersonCategory = (typeof PERSON_CATEGORIES)[number]

export const PERSON_CATEGORY_LABELS = {
  'Leader of the research group': 'Leaders of the Research Group',
  'Team assistant': 'Team Assistants',
  'Team member': 'Team Members',
} satisfies Record<PersonCategory, string>

export const PERSON_CATEGORY_ORDER = [...PERSON_CATEGORIES]

export const TEAM_MEMBER_ROLE_ORDER = {
  'Doctoral Researcher': 0,
  'External PhD': 1,
  'Student Assistant': 2,
} as const

export const PROJECT_STATUSES = ['in progress', 'definitely finished'] as const

export type ProjectStatus = (typeof PROJECT_STATUSES)[number]

export const THESIS_STATUSES = [
  'Available',
  'Reserved',
  'Assigned',
  'Finished',
] as const

export type ThesisStatus = (typeof THESIS_STATUSES)[number]

export const THESIS_LANGUAGES = ['en', 'de'] as const

export type ThesisLanguage = (typeof THESIS_LANGUAGES)[number]
